import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import Button from 'flarum/common/components/Button';
import Separator from 'flarum/common/components/Separator';
import ItemList from 'flarum/common/utils/ItemList';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import listItems from 'flarum/common/helpers/listItems';
import username from 'flarum/common/helpers/username';
import humanTime from 'flarum/common/utils/humanTime';
import formatNumber from 'flarum/common/utils/formatNumber';

// Tag links belong in the in-page navigation of a tag page, not in the global sidebar.
const TAG_ITEM = /^(tag\d+|moreTags|separator)$/;

/**
 * The `PalletSidebar` component is the fixed left column: a user card (or a
 * greeting for guests), the forum navigation, and the session links.
 */
export default class PalletSidebar extends Component {
  view() {
    return m("div", {
      className: "PalletSidebar-container"
    }, m("div", {
      className: "PalletSidebar-user"
    }, app.session.user ? this.userView(app.session.user) : this.guestView()), m("nav", {
      className: "PalletSidebar-nav"
    }, m("ul", null, listItems(this.items().toArray()))));
  }
  userView(user) {
    return m("div", {
      className: "PalletSidebar-loggedIn"
    }, m("div", {
      className: "PalletSidebar-avatar"
    }, m(Avatar, {
      user: user
    }), m("ul", {
      className: "badges"
    }, listItems(user.badges().toArray()))), m("h4", {
      className: "PalletSidebar-username"
    }, username(user)), m("p", {
      className: "PalletSidebar-joined"
    }, app.translator.trans('core.forum.user.joined_date_text', {
      ago: humanTime(user.joinTime())
    })), m("div", {
      className: "PalletSidebar-stats"
    }, m("div", {
      className: "PalletSidebar-stat"
    }, m("span", null, app.translator.trans('core.forum.user.posts_link')), m("span", null, formatNumber(user.commentCount() || 0))), m("div", {
      className: "PalletSidebar-stat"
    }, m("span", null, app.translator.trans('core.forum.user.discussions_link')), m("span", null, formatNumber(user.discussionCount() || 0)))));
  }
  guestView() {
    return m("div", {
      className: "PalletSidebar-guest"
    }, m("h4", null, app.translator.trans('soup-97-palette-theme.forum.howdy')), m("p", null, app.translator.trans('soup-97-palette-theme.forum.involve')), m("div", {
      className: "PalletSidebar-guestButtons"
    }, this.guestButtons().toArray()));
  }
  guestButtons() {
    const items = new ItemList();
    if (app.forum.attribute('allowSignUp')) {
      items.add('signUp', m(Button, {
        className: "Button Button--block",
        onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
      }, app.translator.trans('core.forum.header.sign_up_link')), 20);
    }
    items.add('logIn', m(Button, {
      className: "Button Button--block",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
    }, app.translator.trans('core.forum.header.log_in_link')), 10);
    return items;
  }

  /**
   * The navigation list: the index page's nav items (minus individual tags),
   * followed by the session dropdown's items for logged-in users. Reusing both
   * lists means links added by other extensions show up here too.
   */
  items() {
    const items = new ItemList();
    const nav = new IndexSidebar().navItems();
    for (const key of Object.keys(nav.toObject())) {
      if (!TAG_ITEM.test(key)) items.add(key, nav.get(key), 100 + nav.getPriority(key));
    }
    if (app.session.user) {
      items.add('pallet-separator', m(Separator, null), 0);
      const session = SessionDropdown.prototype.items.call(new SessionDropdown());
      for (const key of Object.keys(session.toObject())) {
        if (key !== 'separator') items.add('session-' + key, session.get(key), session.getPriority(key) - 200);
      }
    }
    return items;
  }
}
flarum.reg.add('soup-97-palette-theme', 'forum/components/PalletSidebar', PalletSidebar);